import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Button, DialogActions, TextField} from "@mui/material";
import {FormElement} from "../molcules/forms";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";

export const CloneKiteDialog = ({open, triggerCloneKite, handleClose, makeTemplate = false }) => {
  const [state, setState] = useState({name: '', targetCustomer: 'All'});

  useEffect(() => {
    if (open && !makeTemplate) {
      setState({name: '', targetCustomer: 'All'});
    }
  }, [open, makeTemplate]);

  return (
    <Dialog open={open} onClose={handleClose}  aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{makeTemplate ? 'Make Template' : 'Clone Kite'}</DialogTitle>
      <DialogContent>
        {!makeTemplate && <div style={{width:'400px', margin:'16px 0'}}>
          <div style={{marginBottom:32}}>
            <TextField
              id={'name'}
              label={'Name'}
              onChange={(e) => {
                setState(prev => ({...prev, name: e.target.value}));
              }}
              value={state.name}
              variant="outlined"
              className="control"
            />
          </div>
          <div style={{marginBottom:32}}>
            <FormElement
              style={{textTransform: 'capitalize'}}
              label={'Select Customer Type'}
              handleChange={(e)=>{
                setState(prev => ({...prev, targetCustomer: e.target.value}));
              }}
              type={'select'}
              id={'targetSelect'}
              selectValues={[ {title: 'All'}, {title: 'Sleeper'}, {title: 'Non Sleeper'} ]}
              values={{targetSelect: state.targetCustomer}}
            />
          </div>
        </div>}
        {makeTemplate && <div style={{width:'400px', margin:'16px 0'}}>
          <p>Are you sure you want to make this a template? This will add this kite to your venue templates section.</p>
        </div>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={() => {
          triggerCloneKite(makeTemplate ? { type: 'template' } : state);
          handleClose();
        }}>{makeTemplate ? 'Make Template' : 'Clone'}</Button>
      </DialogActions>
    </Dialog>
  );
}
